import { WorkflowRepository } from '../domain/workflow.repository'
import { useQuery } from 'react-query'
import { Workflow } from '../domain/workflow'
import { Error } from '../../../shared/domain/error'

export const useGetWorkflowByUUID = (repository: WorkflowRepository, workflowUUID: string) => useQuery<{ workflow: Workflow }, Error>(
  ['workflows-get-by-uuid'],
  async () => await repository.getByUUID(workflowUUID)
)
